import { environment as env } from "src/environments/environment";

export const COUNTRY_DATA_CONTROLLER_ROUTE = env.beBaseUrl + '/api/country-data/';
export const COUNTRY_CONTROLLER_ROUTE = env.beBaseUrl + '/api/country/';
export const REGION_CONTROLLER_ROUTE = env.beBaseUrl + '/api/region/';
export const INITIATIVES_CONTROLLER_ROUTE = env.beBaseUrl + '/api/initiatives/';
export const HOME_CONTROLLER_ROUTE = env.beBaseUrl + '/api/home/';
export const REPORT_CONTROLLER_ROUTE = env.beBaseUrl + '/api/report/';
export const AUTH_CONTROLLER_ROUTE = env.beBaseUrl + '/api/auth/';
export const USER_CONTROLLER_ROUTE = env.beBaseUrl + '/api/user/';
export const PRODUCT_CONTROLLER_ROUTE = env.beBaseUrl + '/api/product/';
export const MECS_COUNTRY_DATA_ROUTE = env.beBaseUrl + '/api/mecs-country-data/';

export const UPSERT_COUNTRY_DATA_ROUTE = `${COUNTRY_DATA_CONTROLLER_ROUTE}` + 'upsert-country-data';
export const GET_COUNTRY_DATA_ROUTE = `${COUNTRY_DATA_CONTROLLER_ROUTE}` + 'get-country-data';

export const GET_COUNTRY_OPTIONS_ROUTE = `${COUNTRY_CONTROLLER_ROUTE}` + 'get-country-options';
export const GET_MECS_COUNTRY_OPTIONS_ROUTE = `${COUNTRY_CONTROLLER_ROUTE}` + 'get-mecs-country-options';
export const GET_ALL_COUNTRIES_ROUTE = `${COUNTRY_CONTROLLER_ROUTE}` + 'get-all-countries';
export const GET_REGION_COUNTRIES = `${COUNTRY_CONTROLLER_ROUTE}` + 'get-region-countries';
export const GET_IN_DEPTH_FILTER_OPTIONS = `${COUNTRY_CONTROLLER_ROUTE}` + 'get-in-depth-filter-options';
export const GET_IN_DEPTH_COUNTRY_LIST = `${COUNTRY_CONTROLLER_ROUTE}` + 'get-in-depth-country-list';

export const GET_REGION_OPTIONS_ROUTE = `${REGION_CONTROLLER_ROUTE}` + 'get-region-options';
export const GET_MECS_REGION_OPTIONS_ROUTE = `${REGION_CONTROLLER_ROUTE}` + 'get-mecs-region-options';
export const GET_REGION_DATA_ROUTE = `${REGION_CONTROLLER_ROUTE}` + 'get-region-data';
export const GET_MECS_FILTER_OPTIONS_ROUTE = `${REGION_CONTROLLER_ROUTE}` + 'get-mecs-filter-options';
export const GET_MECS_REGION_FILTER_OPTIONS_ROUTE = `${REGION_CONTROLLER_ROUTE}` + 'get-mecs-region-filter-options';
export const GET_MECS_REGIONAL_SOLUTION_LAUNCH_PHASE = `${REGION_CONTROLLER_ROUTE}` + 'get-mecs-regional-solution-launch-phase';

export const GET_INITIATIVES_DATA_ROUTE = `${INITIATIVES_CONTROLLER_ROUTE}` + 'get-initiatives-data';

export const GET_GLOBAL_COUNTRIES_DATA_ROUTE = `${HOME_CONTROLLER_ROUTE}` + 'get-global-countries-data';
export const GET_MECS_GLOBAL_COUNTRIES_DATA_ROUTE = `${HOME_CONTROLLER_ROUTE}` + 'get-mecs-global-countries-data';
export const GET_MECS_OVERVIEW_SOLUTION_LAUNCHES = `${HOME_CONTROLLER_ROUTE}` + 'get-mecs-overview-solution-launches';
export const GET_MECS_OVERVIEW_SOLUTION_COUNTRY_PHASE = `${HOME_CONTROLLER_ROUTE}` + 'get-mecs-overview-solution-country-phase';

export const GET_INITIATIVE_OPTIONS_ROUTE = `${HOME_CONTROLLER_ROUTE}` + 'get-initiative-options';

export const GENERATE_PDF_REPORT_ROUTE = `${REPORT_CONTROLLER_ROUTE}` + 'generate-pdf-report';
export const AUTHORIZE_ROUTE = `${REPORT_CONTROLLER_ROUTE}` + 'authorize';

export const GET_ALL_USERS_ROUTE = `${USER_CONTROLLER_ROUTE}` + 'get-all';
export const GET_ONE_USER_ROUTE = `${USER_CONTROLLER_ROUTE}` + 'get-one';
export const EDIT_USER_ROLE_ROUTE = `${USER_CONTROLLER_ROUTE}` + 'edit-user-role';
export const ADD_USER_ROUTE = `${USER_CONTROLLER_ROUTE}` + 'add-user';
export const DELETE_USER_ROUTE = `${USER_CONTROLLER_ROUTE}` + 'delete-user';

export const GET_ALL_PRODUCTS = `${PRODUCT_CONTROLLER_ROUTE}` + 'get-all-products';
export const GET_PRODUCT_MANAGER = `${PRODUCT_CONTROLLER_ROUTE}` + 'get-product-manager';
export const GET_ALL_PRODUCTS_WITH_STATUS = `${PRODUCT_CONTROLLER_ROUTE}` + 'get-all-products-with-status';
export const INSERT_PRODUCT_DATA = `${PRODUCT_CONTROLLER_ROUTE}` + 'insert-product-data';
export const INSERT_PRODUCT = `${PRODUCT_CONTROLLER_ROUTE}` + 'insert-product';

export const ADD_MECS_COUNTRY_DATA = `${MECS_COUNTRY_DATA_ROUTE}` + 'add-mecs-country-data';
export const GET_MECS_COUNTRY_DATA_BY_ID = `${MECS_COUNTRY_DATA_ROUTE}` + 'get-mecs-country-data-by-id';
export const GET_MECS_COUNTRY_CONTACTS_BY_ID = `${MECS_COUNTRY_DATA_ROUTE}` + 'get-mecs-country-contact-details-by-id';